<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客：">
					<el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in customerList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<!-- 收款类型 -->
				<el-form-item label="收款类型：">
					<el-select v-model="formInline.type" placeholder="请选择收款类型" filterable size="small" @change="inputChange">
						<el-option v-for="item in typeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<!-- 支付类型 -->
				<el-form-item label="支付类型：">
					<el-select v-model="formInline.payType" placeholder="请选择支付类型" filterable size="small" @change="inputChange">
						<el-option v-for="item in payTypeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期：">
					<el-date-picker
						v-model="dateStr"
						type="daterange"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						size="small"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="收款内容：">
					<el-input v-model="formInline.content" placeholder="请输入收款内容" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/pay/record', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button v-if="$checkBtnPermission('/pay/record', 'export')" size="small" type="warning" class="el-icon-download" @click="exportPayHistory" :loading="exportLoading">导出</el-button>
				</el-form-item>
			</el-form>
			<div class="table-minheight">
				<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId"></STable>
				<!-- 分页组件 -->
				<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
			</div>
		</topTab>
	<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetPayHistoryPageList, ExportPayHistory } from "@/api/payApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
import { GetCustomerListByStore } from "@/api/baseDataApi.js";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "收款记录"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			exportLoading: false, // 导出按钮 loading
			listData: [],
			selectionList: [],
			dateStr: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				startTime: null,
				endTime: null,
				content: "",
				type: 0,
				payType: 0,
				customerKeyId: ""
			},
			storeList: [],
			userList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					width: "160",
					align: "center"
				},
				{
					prop: "customerName",
					label: "顾客名称",
					isKeep: true,
					width: "100",
					align: "center"
				},
				{
					prop: "typeStr",
					label: "收款类型",
					width: "100",
					align: "center"
				},
				{
					prop: "payTypeStr",
					label: "收款方式",
					width: "100",
					align: "center"
				},
				{
					prop: "payMoney",
					label: "收款金额(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "income"
				},
				{
					prop: "content",
					label: "收款内容",
					minWidth: "300",
					align: "center"
				},
				{
					prop: "payComment",
					label: "收款备注",
					minWidth: "160",
					align: "center"
				},
				{
					prop: "creator",
					label: "经办人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "经办时间",
					width: "170",
					align: "center"
				}
			],
			typeList: [],
			payTypeList: [],
			customerList: [],
			exportBlockVisible: false,
			exportBlockTitle: "",
			exportBlockData: []
		};
	},
	// 注册组件
	components: { exportBlockDialog },
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.GetTypeListByCode();
		this.GetPayTypeListByCode();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				...this.formInline,
				storeKeyId: this.formInline.storeKeyId || null,
				customerKeyId: this.formInline.customerKeyId || null
			};
			GetPayHistoryPageList(params)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 日期选择器事件
		handleDateChange(val) {
			if (val.length > 0) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		// 导出收款记录
		exportPayHistory() {
			// 确认导出
			this.$confirm("确认导出选中门店的收款记录吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
			exportWithLoading(this, "exportLoading", () => ExportPayHistory(this.formInline), "导出失败，请稍后再试！");
			});
		},
		// 获取支付类型
		GetTypeListByCode() {
			const paramer = {
				code: "PayHistoryType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.typeList = [];
						res.data.forEach((item) => {
							this.typeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.typeList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取收款类型失败!");
				});
		},
		// 获取支付类型
		GetPayTypeListByCode() {
			const paramer = {
				code: "PayType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.payTypeList = [];
						res.data.forEach((item) => {
							this.payTypeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.payTypeList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取支付类型失败!");
				});
		},
		// 获取客户信息列表
		GetCustomerList(storeKeyId) {
			const paramer = {
				keyId: storeKeyId
			};
			GetCustomerListByStore(paramer)
				.then((res) => {
					this.customerList = [];
					if (res.code == 1) {
						this.customerList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取客户信息失败!");
				});
		},
		// 门店选择器事件
		handleStoreChange(val) {
			if (val.length > 0) {
				this.formInline.storeKeyId = val;
				this.GetCustomerList(val);
			} else {
				this.formInline.storeKeyId = "";
				this.customerList = [];
			}
		}
	}
};
</script>

<style scoped>
.table-minheight {
	margin-top: 0;
}
</style>

<style scoped></style>
